<template lang="pug">
div
  v-divider
  v-list-tile(@click="select" :to="{name:'ProcessList'}" ripple  id="dropdown-example")
    //- v-list-tile-action.pl-0
    //-   v-icon add_box
    //- v-list-tile-content
    //-   v-list-tile-title {{ $tf("drawer.process.start") }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'HomeDrawer',


  methods: {
    ...mapActions({
      toggleDrawer: 'tools/toggleDrawer',
    }),

    select() {
      if (!this.$vuetify.breakpoint.lgAndUp) {
        this.toggleDrawer()
      }
    },
  },
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/home/HomeDrawer.vue